import type { INavData } from '@coreui/angular-pro';

// ------------------------------
// Depromos ERP – Backoffice NAV
// ------------------------------

const backofficeCatalog: { key: string; item: INavData }[] = [
  {
    key: 'dashboard',
    item: { name: 'Dashboard', url: '/dashboard', iconComponent: { name: 'cil-chart' } },
  },
  {
    key: 'products',
    item: { name: 'Productos', url: '/products', iconComponent: { name: 'cil-tags' } },
  },
  {
    key: 'categories',
    item: { name: 'Categorías', url: '/categories', iconComponent: { name: 'cil-list' } },
  },
  {
    key: 'brands',
    item: { name: 'Marcas', url: '/brands', iconComponent: { name: 'cil-star' } },
  },
  {
    key: 'tallas',
    item: { name: 'Tallas', url: '/sizes', iconComponent: { name: 'cil-grid' } },
  },
  {
    key: 'banners',
    item: { name: 'Banners', url: '/banners', iconComponent: { name: 'cil-image' } },
  },
  {
    key: 'orders',
    item: { name: 'Pedidos', url: '/orders', iconComponent: { name: 'cil-cart' } },
  },
  {
    key: 'dtes_failed_triage',
    item: { name: 'Por revisar', url: '/dtes-triage', iconComponent: { name: 'cil-description' } },
  },
  {
    key: 'picking',
    item: { name: 'Picking', url: '/picking', iconComponent: { name: 'cil-check' } },
  },
  {
    key: 'couriers',
    item: { name: 'Repartidores', url: '/couriers', iconComponent: { name: 'cil-bike' } },
  },
  {
    key: 'courier_deliveries',
    item: { name: 'Mis entregas', url: '/courier-deliveries', iconComponent: { name: 'cil-truck' } },
  },
  {
    key: 'communes',
    item: { name: 'Tarifas por comuna', url: '/communes', iconComponent: { name: 'cil-map' } },
  },
  {
    key: 'customers',
    item: { name: 'Clientes', url: '/customers', iconComponent: { name: 'cil-user' } },
  },
  {
    key: 'customer_levels',
    item: { name: 'Niveles de clientes', url: '/customer-levels', iconComponent: { name: 'cil-badge' } },
  },
  {
    key: 'users',
    item: { name: 'Usuarios', url: '/users', iconComponent: { name: 'cil-people' } },
  },
  {
    key: 'discount_codes',
    item: { name: 'Códigos Descuento', url: '/discount-codes', iconComponent: { name: 'cil-gift' } },
  },
  {
    key: 'notifications',
    item: { name: 'Notificaciones', url: '/push-notifications', iconComponent: { name: 'cil-bell' } },
  },
  {
    key: 'legal-content',
    item: { name: 'Contenidos legales', url: '/legal-contents', iconComponent: { name: 'cil-file' } },
  },
  {
    key: 'faq',
    item: { name: 'Preguntas frecuentes', url: '/faqs', iconComponent: { name: 'cil-comment-square' } },
  },
  {
    key: 'roles',
    item: { name: 'Roles y módulos', url: '/roles', iconComponent: { name: 'cil-settings' } },
  },
];

/**
 * Construye el menú del backoffice según modules{} del JWT.
 * Si modules es undefined/null, retorna el menú completo (modo demo).
 */
export function buildBackofficeNav(modules?: Record<string, boolean> | null): INavData[] {
  if (!modules) {
    return backofficeCatalog.map((x) => x.item);
  }
  // Dashboard ahora es controlado por permisos de rol, no forzado
  return backofficeCatalog
    .filter((x) => !!modules[x.key])
    .map((x) => x.item);
}

/**
 * Ruta de aterrizaje post-login según modules{}. Si el rol no tiene dashboard
 * (ej. Repartidor), aterriza en su primera ruta permitida en vez de /dashboard
 * (que el ModuleGuard rebotaría, dejándolo en un loop).
 */
export function landingRouteFor(modules?: Record<string, boolean> | null): string {
  if (!modules || modules['dashboard']) return '/dashboard';
  const nav = buildBackofficeNav(modules);
  const first = nav.find((n) => typeof n.url === 'string');
  return (first?.url as string) ?? '/dashboard';
}
